/**
 * Accepted numeric ranges for the CDM/OCF/PP lab result fields
 * (HSE "Bloods Data ranges" V3.1, 19-03-2024).
 *
 * HbA1c is enforced at 28–150 mmol/mol — the authoritative entry range from the
 * dataset field-note (Ref 58) and HL7 message spec, stricter than the looser
 * 10–200 HL-ingestion bound.
 *
 * Fields not listed here have no spec-defined range: Non-HDL Cholesterol and
 * Creatinine Clearance are auto-calculated, and TFT/LFT are radio selections.
 */
export const LAB_RANGES = {
  haemoglobin: { min: 2, max: 22, unit: "g/dL" },
  totalCholesterol: { min: 0.1, max: 15, unit: "mmol/l" },
  hdlCholesterol: { min: 0.1, max: 10, unit: "mmol/l" },
  ldlCholesterol: { min: 0.1, max: 15, unit: "mmol/l" },
  triglycerides: { min: 0.1, max: 70, unit: "mmol/l" },
  hba1c: { min: 28, max: 150, unit: "mmol/mol" },
  fastingGlucose: { min: 1, max: 40, unit: "mmol/l" },
  serumCreatinine: { min: 10, max: 2000, unit: "micromol/l" },
  egfr: { min: 0, max: 150, unit: "ml/min/1.73m²" },
  acr: { min: 0, max: 5000, unit: "mg/mmol" },
  ntProBNP: { min: 0, max: 20000, unit: "pg/ml" },
};
